export default __webpack_public_path__ + "static/cheer-trackers-vertical-e202d9907c86738f208408e2b0494ad8.png";